import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import Feeds from './components/Feeds'
import queryString from 'query-string'
import WelcomeBanner from 'srcReact/components/common2/WelcomeBanner'
import { isHDScreen, getFlaggedColor, isMobileScreen } from 'srcReact/helpers/utils'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import { redirectToPage } from 'srcReact/helpers/history'
import ReviewActionButton from 'srcReact/components/common2/ReviewActionButton'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { getWorkplaceIds } from 'srcReact/helpers/workplaceHelper'
import { generalFeedActions } from './actions'
import CTAMemberActivities from './components/CTAMemberActivities'

const FeedPageContainer = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    alert,
    common: { isNative, isMobile, isDesktop },
    feedHome: { moderation_info },
    commonNewsfeed: { authUser },
    organization: {
      current_organization,
      header: { user_properties }
    }
  } = useSelector((state) => state)

  // const [isMobile, setIsMobile] = useState(isMobileScreen())
  // const [isDesktop, setIsDesktop] = useState(isWideScreen())
  const [isHD, setIsHD] = useState(isHDScreen())
  const [feedIdToScroll, setFeedIdToScroll] = useState(0)
  const [showMemberActivityCTA, setShowMemberActivityCTA] = useState(true)
  const [showProfileCTA, setShowProfileCTA] = useState(false)

  // Get flag reasons
  useEffect(() => {
    const organizationId = getCurrentOrgId()
    const workplaceIds = getWorkplaceIds(current_organization)
    dispatch(moderationReportActions.getFlagReasons())
    dispatch(generalFeedActions.getGeneralFeedCTAs(organizationId, workplaceIds, 'all', 0))

    let locationObj = queryString.parse(location.search)
    if (locationObj?.feed) {
      const feedId = locationObj.feed
      if (feedId && feedId > 0) {
        setFeedIdToScroll(feedId)
        if (isMobileScreen()) {
          redirectToPage(`/0/feed-content/general/${organizationId}/${feedId}`, isNative)
        }
      }
    }

    //manage window size
    window.scrollTo(0, 0)
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  // useEffect(() => {
  //   if (user_properties?.profile_completion) {
  //     let displayCTAAfterDuration = false
  //     let closedAt = new Date(`${user_properties.profile_completion.last_closed_at} UTC`)
  //     if (isValidDate(closedAt)) {
  //       const diff = dateDiffInSeconds(new Date(), closedAt)
  //       displayCTAAfterDuration = diff > appConstantSettings.MY_PROFILE_CTA_DURATION
  //     } else {
  //       //if date is in form of 0000-00-00 00:00:0, then display ctas
  //       displayCTAAfterDuration = true
  //     }

  //     if (displayCTAAfterDuration) {
  //       let showProfileCTA = false
  //       for (let field in user_properties.profile_completion) {
  //         if (user_properties.profile_completion[field] === 0) {
  //           showProfileCTA = true
  //           break
  //         }
  //       }
  //       setShowProfileCTA(showProfileCTA)
  //       setShowMemberActivityCTA(!showProfileCTA)
  //     } else {
  //       setShowProfileCTA(displayCTAAfterDuration)
  //       setShowMemberActivityCTA(!displayCTAAfterDuration)
  //     }
  //   }
  // }, [user_properties])

  const handleWindowSizeChange = () => {
    // setIsMobile(isMobileScreen())
    // setIsDesktop(isWideScreen())
    setIsHD(isHDScreen())
  }

  return (
    <PageContainer pageTitle={t('feed.title')} pageClassName={styles.mainPage} withFooter={false} withSidebar={true}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      <WelcomeBanner firstname={authUser?.firstname} isNative={isNative} />
      <div className={`${styles.feedWrapper} ${isHD && styles.isHD} ${isNative && styles.nativeFeedWrapper}`}>
        {moderation_info.flagged_posts >= 1 && (
          <ReviewActionButton
            iconName='flag-icon'
            text={t('moderationReport.flaggedContentItem', {
              count: moderation_info.flagged_posts,
              item: moderation_info.flagged_posts > 1 ? t('moderationReport.item') : t('moderationReport.item')
            })}
            color={getFlaggedColor(moderation_info.flagged_posts)}
            handleClick={() => redirectToPage(`/0/moderation?tab=awaiting_review`, isNative)}
          />
        )}
        {showMemberActivityCTA && <CTAMemberActivities />}
        {/* {showProfileCTA && <CTAMyProfile origin='feed' />} */}
        <Feeds
          isMobile={isMobile}
          isDesktop={isDesktop}
          isNative={isNative}
          feedIdToScroll={feedIdToScroll}
          setFeedIdToScroll={setFeedIdToScroll}
        />
      </div>
    </PageContainer>
  )
}

export { FeedPageContainer }
